import { render, staticRenderFns } from "./MatchPlayerRecord.vue?vue&type=template&id=779b5df6&scoped=true"
import script from "./MatchPlayerRecord.vue?vue&type=script&lang=js"
export * from "./MatchPlayerRecord.vue?vue&type=script&lang=js"
import style0 from "./MatchPlayerRecord.vue?vue&type=style&index=0&id=779b5df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b5df6",
  null
  
)

export default component.exports